<template>
  <div class="check_bar">
    <div class="check_bar_arr"
        v-for="(item, i) in checkbar"
        :key="i"
        :style="i === checkbar.length -1 ? 'margin-bottom: 0px;' : ''"
    >
      <div class="checkbox checkbox__theme_default"
        :class="item.check === true ? 'check_active' : ''">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.71694 8.27013L3.88883 6.44202L3.79602 6.34921L3.70322 6.44202L2.87838 7.26686L2.78558 7.35966L2.87838 7.45247L5.62413 10.1982L5.71694 10.291L5.80975 10.1982L11.4722 4.5358L11.565 4.443L11.4722 4.35019L10.6473 3.52536L10.5545 3.43255L10.4617 3.52536L5.71694 8.27013Z" fill="white" stroke="white" stroke-width="0.2625"/>
        </svg>
      </div>
      <div class="check_text">
        {{item.name}}
      </div>
    </div>
    <div class="line"
         v-if="checkbar.length > 0 && buttons.length > 0"
    >
    </div>
    <div class="info" v-if="info !== null">
      <div class="text">
        {{info.info}}
      </div>
      <div class="text_count">
        {{info.count}}
      </div>
    </div>
    <div class="button"
         :class="{
            'button_not_checkbar': checkbar.length === 0,
            'button_is_checkbar': checkbar.length > 0,
         }"
    >
      <div class="buttons"
          v-for="(item, i) in buttons"
          :key="i"
      >
        <button class="btn"
                :class="item.type"
                @click="send(item)"
        >
          {{item.name}}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "CheckBar",
    props:{
      checkbar:{
        type: Array,
        default: () =>{
          return []
        }
      },
      info:{
        type: Object,
        default: () =>{
          return null
        }
      },
      buttons:{
        type: Array,
        default: () =>{
          return []
        }
      },
    },
    data() {
      return {

      }
    },
    methods: {
      send(item){
        switch (item.type){
          case 'skip':
            this.$emit("skipStep");
            break;
          case 'active':
            this.$emit("goToNextStep");
            break;
          case 'delete':
            this.$emit("delete");
            break;
          case 'blocked':
            this.$emit("blockedActive");
            break;
        }
      }
    },
    components:{

    }
  }
</script>

<style lang="scss" scoped>
  @import "../../style/styles_fonts";

  $color_black: #333333;
  $color_white: #FFFFFF;
  $color_Grey_5: #8D909F;
  $color_Grey_3: #EBEBEB;
  $color_Grey_2:  #ABABB2;
  $color_green: #89CE54;
  $color_purple:  #8C71FE;
  $color_purple_1: #7B61EB;
  $color_red: #FF6597;
  $font_Geometria: Geometria, 'Geometria';

  .fade-enter-active, .fade-leave-active {
    transition: opacity ease .5s;
  }
  .fade-enter-from, .fade-leave-to {
    opacity: 0;
  }

  .check_bar{
    padding: 24px;
    background: $color_white;
    border: 1px solid $color_Grey_3;
    border-radius: 16px;
  }
  .check_bar_arr{
    display: flex;
    align-items: center;
    margin-bottom: 22px;
  }
  .checkbox__theme_default{
    margin-right: 12px;
    box-sizing: border-box;
    width: 28px;
    height: 28px;
    max-width: 28px;
    max-height: 28px;
    border: 2px solid #C0CADC;
    border-radius: 50%;
    transition: all 0.25s;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  .checkbox__theme_default svg {
    width: 18px;
    height: auto;
  }

  .check_active{
    background: $color_green;
    border-color: $color_green;
  }
  .check_text{
    font-family: $font_Geometria;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: $color_black;
  }
  .line{
    margin: 22px 0 0px 0;
    height: 1px;
    background: $color_Grey_3;
  }
  .info{
    margin: 22px 0 0px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .text{
      font-family: $font_Geometria;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 140%;
      color: $color_black;
    }
    .text_count{
      font-family: $font_Geometria;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 140%;
      color: $color_Grey_2;
    }
  }

  .button{
    display: grid;
    grid-gap: 12px;
  }

  .button_not_checkbar{
    margin: 0;
  }

  .button_is_checkbar{
    margin: 22px 0 0 0;
    width: 100%;
  }

  .btn {
    padding: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    outline:0;
    border-radius: 8px;
    font-family: $font_Geometria;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    border: 0;
    height: 52px;
  }
  .blocked{
    transition: all 0.25s;
    background: $color_Grey_3;
    color: $color_Grey_5;
  }
  .active{
    cursor: pointer;
    background: $color_purple;
    color: $color_white;
    transition: all 0.5s;
  }
  .active:hover{
    background: $color_purple_1;
  }
  .skip{
    cursor: pointer;
    border: 1px solid $color_purple;
    background: $color_white;
    color: $color_purple;
    transition: all 0.5s;
  }
  .skip:hover{
    background: $color_purple;
    color: $color_white;
  }
  .delete{
    cursor: pointer;
    border: 1px solid $color_red;
    background: $color_white;
    color: $color_red;
    transition: all 0.5s;
  }
  .delete:hover{
    background: $color_red;
    color: $color_white;
  }
  @media all and (max-width: 1600px) {
    .check_bar{
      padding: 21px;
    }
    .check_bar_arr{
      margin-bottom: 21px;
    }
    .line{
      margin: 20px 0 0px 0;
    }
    .info{
      margin: 20px 0 0px 0;

      .text{
        font-size: 15px;
        line-height: 140%;
      }
      .text_count{
        font-size: 15px;
        line-height: 140%;
      }
    }

    .button_is_checkbar{
      margin: 18px 0 0 0;
    }

    .button{
      grid-gap: 10px;
    }

    .btn {
      font-size: 15px;
      line-height: 19px;
      height: 46px;
    }

    .check_text {
      font-size: 15px;
      line-height: 19px;
    }

    .checkbox__theme_default{
      width: 26px;
      height: 26px;
      max-width: 26px;
      max-height: 26px;
    }

    .checkbox__theme_default svg {
      width: 16px;
      height: auto;
    }
  }
  @media all and (max-width: 1440px) {
    .check_bar{
      padding: 18px;
      border-radius: 10px;
    }
    .check_bar_arr{
      margin-bottom: 20px;
    }
    .checkbox__theme_default{
      margin-right: 10px;
      width: 24px;
      height: 24px;
      max-width: 24px;
      max-height: 24px;
      border-width: 1px;
    }
    .check_text{
      font-size: 14px;
      line-height: 18px;
    }
    .line{
      margin: 18px 0 0px 0;
    }
    .info{
      margin: 18px 0 0px 0;

      .text{
        font-size: 14px;
        line-height: 140%;
      }
      .text_count{
        font-size: 14px;
        line-height: 140%;
      }
    }

    .button_is_checkbar{
      margin: 14px 0 0 0;
    }

    .button{
      grid-gap: 9px;
    }

    .btn {
      border-radius: 6px;
      font-size: 14px;
      line-height: 18px;
      height: 42px;
    }

    .checkbox__theme_default svg {
      width: 14px;
      height: auto;
    }
  }
  @media all and (max-width: 1280px) {
    .check_bar{
      padding: 16px;
    }
    .check_bar_arr{
      margin-bottom: 18px;
    }

    .line{
      margin: 16px 0 0px 0;
    }
    .info{
      margin: 16px 0 0px 0;
    }

    .button_is_checkbar{
      margin: 10px 0 0 0;
    }

    .button{
      grid-gap: 8px;
    }
  }
  @media all and (max-width: 1160px) {
    .check_bar{
      padding: 0;
      background:  rgba(0,0,0,0);
      border: 0 solid $color_Grey_3;
      border-radius: 0;
    }
    .check_bar_arr{
      display: none;
    }
    .line{
      display: none;
    }
    .info{
      display: none;
    }

    .button{
      margin: 0;
      grid-gap: 21px;
    }

    .btn {
      border-radius: 10px;
      font-size: 15px;
      line-height: 19px;
      height: 50px;
    }

    .skip {
      background-color: rgba(255, 255, 255, 0);
    }

    .active:hover {
      background: $color_purple;
    }

    .skip:hover {
      background: rgba(140, 113, 254, 0);
      color: $color_purple;
    }
  }
  @media all and (max-width: 960px) {
    .check_bar{
      padding: 0;
      background:  rgba(0,0,0,0);
      border: 0 solid $color_Grey_3;
      border-radius: 0;
    }
    .check_bar_arr{
      display: none;
    }
    .line{
      display: none;
    }
    .info{
      display: none;
    }
    .button{
      margin: 0;
      grid-gap: 8px;
    }

    .button {
      grid-gap: 18px;
    }
  }

  @media all and (max-width: 600px) {
    .btn {
      height: 44px;
      border-radius: 6px;
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
    }

    .button {
      grid-gap: 16px;
    }

    .block__theme_discount {
      margin-bottom: 16px;
    }
  }
</style>
